function initSliders(){
  if(document.querySelector('.cart-upsells-slider')){
    new Flickity(".cart-upsells-slider .inner", { 
        "cellAlign": "center", "contain": true, 
        "prevNextButtons": true, "pageDots": true, 
        "wrapAround": true
    })
  }
  if(document.querySelector('.cart-info-slider')){
    new Flickity(".cart-info-slider .inner", { 
        "cellAlign": "center", "contain": true, 
        "prevNextButtons": false, "pageDots": true,
        "autoPlay": 3500, "wrapAround": true
    })
  }
}
//initSliders();
document.addEventListener("cart:change", (event) => {
  initSliders();
});



if (!customElements.get('custom-cart-drawer')) {
    customElements.define('custom-cart-drawer', class CCartDrawer extends HTMLElement {
        constructor() {
            super();
            this.overlay = this.querySelector('.ccd-overlay');
            this.timer = this.querySelector('.ccd-countdown');
            this.form = this.querySelector('form');
            this.debouncedOnChange = this.debounce((event) => {
                this.onChange(event);
            }, 300);
            this.addEventListener('change', this.debouncedOnChange.bind(this));
            this.initEvents(); 
            this.init(); 
        }

        initEvents(){
            this.overlay.addEventListener('click', this.close.bind(this))
            this.form.addEventListener('submit', this.checkout.bind(this))
        }

        init(){
            if(!this.timer.classList.contains('hidden')){
                this.initCountdown(parseInt(this.timer.getAttribute('duration')));
            }
        }

        initCountdown(minutes, seconds=0){
            var endTime, hours,msLeft, mins, time;

            
            let msLeftSaved = parseInt(localStorage.getItem('ccd_countdown'));
            endTime = (+new Date) + 1000 * (60*minutes + seconds) + 500;
            if(msLeftSaved) endTime = (+new Date) + msLeftSaved;
            
            this.timerInterval = setInterval(() => {
                updateTimer();
            }, 1000);
            setTimeout(()=> {this.timer.classList.remove('hidden')}, 1001)
            
            function twoDigits( n ){return (n <= 9 ? "0" + n : n);}
            
            function updateTimer(){
              var element = document.querySelector('.ccd-countdown__timer');
                msLeft = endTime - (+new Date);
                if ( msLeft < 1000 ) {
                    element.innerHTML = "00:00";
                    //clear?
                    let cartPopup = document.querySelector('custom-cart-drawer');
                    cartPopup.clearCountdown();
                    cartPopup.clear();
                }
                else {
                    time = new Date( msLeft );
                    hours = time.getUTCHours();
                    mins = time.getUTCMinutes();
                    element.innerHTML = (hours ? hours + ':' + twoDigits( mins ) : mins) + ':' + twoDigits( time.getUTCSeconds() );
                    localStorage.setItem('ccd_countdown', msLeft);
                    endTime = (+new Date) + msLeft
                }

            }
        }
        clearCountdown(){
            clearInterval(this.timerInterval);
            localStorage.removeItem('ccd_countdown');
            this.timerInterval = null;
            this.timer.classList.add('hidden');
        }
        
        onChange(event){
            let item = event.target.closest('[item-container]');
            if (item) {
                item.classList.add('loading');
                let loader = item.querySelector('.loader');
                if (loader) {
                    loader.classList.remove('hidden');
                }
            }
            this.updateQuantity(event.target.dataset.item, event.target.value);
        }

        open(){
            this.getCartItems();
        }

        show(){
            this.setAttribute('open', true);
            document.body.classList.add('cart-drawer_opened');
          initSliders();
        }

        close(){
            this.removeAttribute('open'); 
            document.body.classList.remove('cart-drawer_opened');
            document.body.classList.remove('js-drawer-open');
        }

        getCartItems(){
            let sections = this.getSectionsToRender();
            fetch(`${routes.cart_url}/?sections=${sections.join(',')}`)
            .then((response) => {
                return response.json();
            })
            .then((parsedState) => {
                //const parsedState = JSON.parse(state);
                this.replaceElements('cart-drawer', parsedState['cart-drawer']);
                this.headerReplaceElements(parsedState['cart-icon-bubble']);
                if(!this.timerInterval){
                    this.initCountdown(parseInt(this.timer.getAttribute('duration')));
                }
                document.documentElement.dispatchEvent(new CustomEvent("cart:change", {
                    bubbles: true,
                    detail: {
                        cart: parsedState
                    }
                }));
            }).finally(()=>{
                this.show();
            })
            .catch((e) => {
                console.log(e);
                alert('cart api error');
            });
        }

        add(variantId, qty){
            const body = JSON.stringify({
                items: [
                    { 
                        quantity: qty,
                        id: variantId
                    }
                ],
                sections: this.getSectionsToRender(),
            });
            fetch(`${routes.cart_add_url}`, { ...this.fetchConfig('javascript'), body })
            .then((response) => response.text())
            .then((state) => {
                const parsedState = JSON.parse(state);
                this.replaceElements('cart-drawer', parsedState.sections['cart-drawer']);
                this.headerReplaceElements(parsedState.sections['cart-icon-bubble']);
                if(!this.timerInterval){
                    this.initCountdown(parseInt(this.timer.getAttribute('duration')));
                }
                document.documentElement.dispatchEvent(new CustomEvent("cart:change", {
                    bubbles: true,
                    detail: {
                        cart: parsedState
                    }
                }));
            })
            .catch((e) => {
                console.error(e);
                console.log('operation failed');
            })
        }

        clear(){
            let sections = this.getSectionsToRender();
            fetch(`${routes.cart_clear_url}/?sections=${sections.join(',')}`,{ ...this.fetchConfig('javascript')})
            .then((response) => {
                return response.text();
            })
            .then((state) => {
                const parsedState = JSON.parse(state);
                this.replaceElements('cart-drawer', parsedState.sections['cart-drawer']);
                this.headerReplaceElements(parsedState.sections['cart-icon-bubble']);
                this.clearCountdown();
                console.log('Panier vidé !!!');
            })
            .catch((e) => {
                console.error(e);
                console.log('operation failed');
            })
        }

        updateQuantity(itemId, qty){
            const body = JSON.stringify({
                updates:{
                    [itemId]: qty
                },
                sections: this.getSectionsToRender(),
                sections_url: window.location.pathname
            });
            fetch(`${routes.cart_update_url}`, {...this.fetchConfig('javascript'),...{ body }})
            .then((response) => {
                return response.text();
            })
            .then((state) => {
                const parsedState = JSON.parse(state);
                this.replaceElements('cart-drawer', parsedState.sections['cart-drawer']);
                this.headerReplaceElements(parsedState.sections['cart-icon-bubble']);
                document.documentElement.dispatchEvent(new CustomEvent("cart:change", {
                    bubbles: true,
                    detail: {
                        cart: parsedState
                    }
                }));
                if(parsedState.item_count < 1) this.clearCountdown();
            }).catch((e) => {
                console.log(e);
                alert('cart api error');
            });
    
        }

        checkout(e){
            e.preventDefault();
            this.form.querySelector('button').classList.add('desabled');
            let promos = this.querySelectorAll('[promo-item]');
            let items = Array.prototype.map.call(promos, p => (
                {
                    quantity: 1,
                    id: p.getAttribute('promo-item')
                }
            ))
            if (items.length) {
                const body = JSON.stringify({items});
                fetch(`${routes.cart_add_url}`, { ...this.fetchConfig('javascript'), body })
                .then((response) => response.text())
                .then((state) => {
                    location.href = '/checkout'
                })
                .catch((e) => {
                    console.error(e);
                    alert('failed to add promo product');
                })
            }else{
                location.href = '/checkout'
            }
        }

        replaceElements(section, html){
            const el = {
                'cart-drawer': ['.ccd-container-midle_replace', '.ccd-payment'],
            }
            let needle = el[section];
            needle.forEach(n =>{
                let s = document.querySelector(n);
                if(s) s.innerHTML = this.getSectionInnerHTML(html, n)
            })
        }
        headerReplaceElements(html){
            const el = [
                '.cart-item-count-header--has-label.cart-item-count-header--quantity', 
                '#drawer-cart-count', 
                '.cart-item-count-header--has-label.cart-item-count-header--total',
                '.header--supporting-text .cart-item-count-header--quantity',
                '.header--supporting-text .cart-item-count-header--total',
                '[mobile] .cart-item-count-header--quantity',
                '[mobile] .cart-item-count-header--total',
            ]
            el.forEach(n =>{
                let d = document.querySelector(n);
                if(d){
                    let ne = this.getSectionInnerHTML(html, n, false);
                    d.parentNode.replaceChild(ne, d);
                }
            })
        }
    
        getSectionInnerHTML(html, selector = '.shopify-section', inner=true) {
            let el = new DOMParser().parseFromString(html, 'text/html').querySelector(selector);
            if(!inner) return el;
            if(el) return el.innerHTML;
            return ''
        }
    
        getSectionsToRender(){
            let r = ['cart-drawer', 'cart-icon-bubble'];
            return r;
        }
        debounce(fn, wait) {
            let t;
            return (...args) => {
                clearTimeout(t);
                t = setTimeout(() => fn.apply(this, args), wait);
            };
        }
        fetchConfig(type = 'json') {
            return {
                method: 'POST',
                headers: { 'Content-Type': 'application/json', 'Accept': `application/${type}` }
            };
        }

    });
}


class CartOpenBtn extends HTMLElement {
    constructor() {
        super();
        this.cartPopup = document.querySelector('custom-cart-drawer');
        this.btn = this.querySelector('a');
        this.btn.addEventListener('click', (e) => {
            e.preventDefault();
            if(this.cartPopup) return this.cartPopup.show();
            location.href = routes.cart_url;
        })
    }

}
customElements.define('cart-open-button', CartOpenBtn);

class CartCloseBtn extends HTMLElement {
    constructor() {
        super();
        this.btn = this.querySelector('a');
        this.btn.addEventListener('click', (e) => {
            e.preventDefault();
            let cartPopup = document.querySelector('custom-cart-drawer');
            if(cartPopup) return cartPopup.close();
        })
    }

}
customElements.define('cart-close-button', CartCloseBtn);

class CartRemoveBtn extends HTMLElement {
    constructor() {
        super();
        this.addEventListener('click', (event) => {
            let item = event.target.closest('[item-container]');
            if (item) {
                item.classList.add('loading');
                let loader = item.querySelector('.loader')
                if (loader) {
                    loader.classList.remove('hidden')
                }
            }
            event.preventDefault();
            this.closest('custom-cart-drawer').updateQuantity(this.dataset.item, 0);
        });
    }

}
customElements.define('ccd-remove-button', CartRemoveBtn);
class CartRemovePromoBtn extends HTMLElement {
    constructor() {
        super();
        this.addEventListener('click', (event) => {
            let item = event.target.closest('[item-container]');
            if (item) {
                item.remove();
            }
            event.preventDefault();
        });
    }
}
customElements.define('ccd-remove-button-promo', CartRemovePromoBtn);

class CartAddBtn extends HTMLElement {
    constructor() {
        super();
        this.addEventListener('click', (event) => {
            let item = event.target.closest('[item-container]');
            let qty = item.querySelector('.quantity__input');
            if (item) {
                item.classList.add('loading');
                let loader = item.querySelector('.loader')
                if (loader) {
                    loader.classList.remove('hidden')
                }
            }
            event.preventDefault();
            this.closest('custom-cart-drawer').add(this.dataset.item, qty ? qty.value : 1);
        });
    }

}
customElements.define('ccd-add-button', CartAddBtn);

class QuantityInput extends HTMLElement {
    constructor() {
        super();
        this.input = this.querySelector('input');
        this.changeEvent = new Event('change', { bubbles: true })
        this.querySelectorAll('button').forEach(
            (button) => button.addEventListener('click', this.onButtonClick.bind(this))
        );
    }
    
    onButtonClick(event) {
        event.preventDefault();
        const previousValue = parseInt(this.input.value);
        // event.target.name === 'plus' ? this.input.setAttribute('value', previousValue+1)  : this.input.setAttribute('value', previousValue-1) ;
        event.target.name === 'plus' ? this.input.stepUp()  : this.input.stepDown() ;
        if (previousValue !== parseInt(this.input.value) && !this.hasAttribute('noevent')) this.input.dispatchEvent(this.changeEvent);
    }
}
customElements.define('ccd-quantity-input', QuantityInput);